import React from 'react';
import Template from '../../../layout/Template';



const ContasApagar = () =>{

    return (
        <Template>
            <h3>Contas a pagar</h3>
        </Template>
    )
}
export default ContasApagar;